import { render, staticRenderFns } from "./FirePersonalPropertyDescriptionQuestion.vue?vue&type=template&id=53ed466a"
import script from "./FirePersonalPropertyDescriptionQuestion.vue?vue&type=script&lang=ts"
export * from "./FirePersonalPropertyDescriptionQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports